import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';




import {ApiMessageService} from '../../core/api-message.service';
import {CommonService} from '../../common/controller/common.service';
import {Persona} from './persona.model';
import {Router} from '@angular/router';
import {JsonBaseBuilder} from '../../common/builder/json-base-builder';
import {ConfigService} from '../../core/config.service';
import {Table} from '../../common/model/table.model';
import {MODULE_ANAGRAFICA} from '../../app-routing.module';

@Injectable()
export class PersonaService extends CommonService<Persona> {

  public static ROUTE = 'persona';

  public constructor(protected httpClient: HttpClient,
                     protected apiMessageService: ApiMessageService,
                     protected router: Router,
                     protected configService: ConfigService) {
    super(httpClient, apiMessageService, router, configService);
  }

  public buildInstance(json: any): Persona {
    return JsonBaseBuilder.jsonToPersona(json);
  }

  public getModule(): string {
    return MODULE_ANAGRAFICA;
  }

  public getApiService(): string {
    return ConfigService.ACE;
  }

  public getRoute(): string {
    return PersonaService.ROUTE;
  }

  public getTable(items: Persona[]): Table {
    return Table.buildBaseTable(Persona.getTableKeys(), items);
  }
}
